import { configAboutUs } from "@pub/config";
import { AuthorProfile } from "@sphtech/dmg-design-system";
import {
  ResolvedAuthorProfileElement,
  ResolvedCUEElement,
} from "@src/app/layouts/Article/elements";
import cx from "classnames";
import { ComponentProps } from "react";

import styles from "./authorblock.module.css";
type Props = {
  data: ResolvedAuthorProfileElement[];
  profileHeadlineElement?: ResolvedCUEElement;
  readMoreText?: string;
  imageFill?: ComponentProps<typeof AuthorProfile>["imageFill"];
};

export default function AuthorBlock({
  data,
  profileHeadlineElement,
  readMoreText,
  imageFill,
}: Props) {
  return (
    <div className={cx(styles.container, styles.gutter)}>
      <div className={styles.bodyContainer}>
        <h2 className={styles.heading}>
          {profileHeadlineElement?.type === "sub_head"
            ? profileHeadlineElement.additionalFields.subhead?.value
            : configAboutUs.profileBlock?.heading}
        </h2>
        <div className={styles.list}>
          {data.map(
            (element, index) =>
              element.resolvedData && (
                <AuthorProfile
                  key={index}
                  {...element.resolvedData}
                  link={element.resolvedData.urlPath}
                  showVerticalLine={false}
                  readMoreText={readMoreText}
                  imageFill={imageFill}
                />
              ),
          )}
        </div>
      </div>
    </div>
  );
}
